import request from '@/utils/request'
const apiPath = '/cust_service/custServiceContacts'
const custServiceContactsApi = {
  creatRemark(data) {
    return request.post(apiPath + '/tee', data)
  },
  updateRemark(data) {
    return request.put(apiPath + '/tee', data)
  },
}
export default custServiceContactsApi
